/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1f103fdd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f103fdd&lang=css"

import exportComponent from "D:\\un-app\\ys_wuxie_webview_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__